import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import {validateReasoning} from "../../utilities/reasoningValidation";

/**
 * @property {Help_Desks_Object} state
 * @property {object} model
 * @property {Help_Desks_Properties} model.properties
 *
 */

class DispatcherTracker extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Users_Inactive._name);
	}

	handleSubmit(event) {
		const error = validateReasoning(this.state.reasoning);
		if (error) {
			this.setState({reasoning_error: error});
			return;
		}
		super.handleSubmit(event, true);
	}

	form = () => {
		/**
		 * @param {Calendar_Help_Desk_Notes_Properties} data
		 */
		let {properties} = this.model;

		/**
		 * @type {Calendar_Help_Desk_Notes_Object} object
		 */
		let object = this.state;
		return (
			<fieldset>
				<div className={'row'} style={{justifyContent: "center"}}>
						You've been inactive, please state a reasoning below to continue work
					<div className={'col-12'}>
						<div className="form-group">
							<Framework.Elements.TextField
								property={properties.reasoning}
								value={object.reasoning}
								error={object.reasoning_error}
								update={this.handleTextFieldPropertyUpdate}
								multiline={4}
							/>
						</div>
					</div>
				</div>
			</fieldset>
		)
	}
}

export default Framework.Components.withRootState(DispatcherTracker);
